export default class NumberUtils {

	static parseNumber(numberString: string) {
		let numberStr = numberString;
		if (!numberString) {
			return 0
		}
		numberStr = numberString.replace("," , ".");
		return parseFloat(numberStr)
	}

}



// WEBPACK FOOTER //
// ./src/app/utils/number.utils.ts